import { ProfileScreenRoute } from "@components/Account/Layout/utils";
import CapsuleButton from "@components/CapsuleButton";
import LBox from "@components/LBox";
import LLink from "@components/LLink";
import { useNavigationStore } from "@utils/navigation/useNavigationStore";

const SubHeader = ({ routes }: { routes: ProfileScreenRoute[] }) => {
  const pathName = useNavigationStore((state) => state.currentPath);
  const handlePress = () => {};

  return (
    <LBox alignItems="center" flexDirection="row" gap="s2">
      {routes.map(({ route, title }) => {
        const routeString = route.toString();
        const active = routeString.includes(pathName);

        return (
          <LLink
            asChild
            disabled={active}
            href={route}
            key={routeString}
            replace
            pressable={false}
          >
            <CapsuleButton
              isSelected={active}
              onPress={handlePress}
              title={title}
            />
          </LLink>
        );
      })}
    </LBox>
  );
};

export default SubHeader;
